const DEFAULT_SKEW_MS = 60_000;

export function getJwtExpMs(token: string | null): number | null {
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}

export function isAccessExpired(
  expiresAt?: Date | null,
  token?: string | null,
  skewMs: number = DEFAULT_SKEW_MS,
): boolean {
  const now = Date.now();
  if (expiresAt && !Number.isNaN(expiresAt.getTime())) {
    return now >= expiresAt.getTime() - skewMs;
  }
  const jwtExp = getJwtExpMs(token ?? null);
  if (jwtExp != null) {
    return now >= jwtExp - skewMs;
  }
  return false;
}

export function shouldRefreshSoon(
  expiresAt?: Date | null,
  token?: string | null,
  thresholdMs: number = 5 * 60 * 1000,
): boolean {
  const now = Date.now();
  let targetMs: number | null = null;
  if (expiresAt && !Number.isNaN(expiresAt.getTime())) {
    targetMs = expiresAt.getTime();
  } else {
    targetMs = getJwtExpMs(token ?? null);
  }
  if (targetMs == null) return false;
  return now >= targetMs - thresholdMs;
}

export function msUntilRefresh(
  expiresAt?: Date | null,
  token?: string | null,
  thresholdMs: number = 5 * 60 * 1000,
): number | null {
  const now = Date.now();
  let targetMs: number | null = null;
  if (expiresAt && !Number.isNaN(expiresAt.getTime())) {
    targetMs = expiresAt.getTime();
  } else {
    targetMs = getJwtExpMs(token ?? null);
  }
  if (targetMs == null) return null;
  const ms = targetMs - thresholdMs - now;
  return ms > 0 ? ms : 0;
}
